import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useContext } from "react";
import { GetPlans, PlansData } from "../../services/app/PlansRequest";
//import PlanCard from "./PlanCard";

import "../../styles/app/PlansSection.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../contexts/ThemeContext";

const PlansSection: React.FC = () => {
  const { t } = useTranslation();

  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { isLightMode } = themeContext;

  const [plans, setPlans] = useState<PlansData[]>([]);

  useEffect(() => {
    const fetchPlansData = async () => {
      try {
        const response = await GetPlans();
        let plansData = response.data;

        if (process.env.REACT_APP_DEFAULT_LANGUAGE === "en") {
          plansData = plansData.map((plan) => {
            if (plan.name === "INICIACIÓN") {
              return { ...plan, name: "STARTER" };
            }
            if (plan.name === "BÁSICO") {
              return { ...plan, name: "BASIC" };
            }
            return plan;
          });
        }

        setPlans(plansData);
      } catch (error) {
        console.error("Error fetching plans data:", error);
      }
    };

    fetchPlansData();
  }, []);

  return (
    <section
      id="plans"
      className="plans-section"
      data-theme={isLightMode ? "light" : "dark"}
    >
      <div className="plans-heading">
        <h1 className="plans-title">{t("plansSection.title")}</h1>
        <p className="plans-subtitle">{t("plansSection.subtitle")}</p>
        <p className="plans-desc">{t("plansSection.description")}</p>
      </div>
      {/*
      <div className="plans-card-grid">
        {props.map((p, index) => (
          <PlanCard key={index} {...p} />
        ))}
      </div>
      */}
      <div className="plans-table-container">
        <table className="plans-table">
          <thead className="plans-table-header">
            <tr>
              <th>{t("plansSection.features")}</th>
              {plans.map((plan) => (
                <th key={plan.id}>{plan.name}</th>
              ))}
            </tr>
          </thead>
          <tbody className="plans-table-body">
            <tr>
              <td>{t("plansSection.llm")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>{plan.llm}</td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.price")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>
                  {plan.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  {t("plansSection.usdPerMonth")}
                </td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.minutesIncluded")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>
                  {plan.minutes
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.additionalMinutes")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>{plan.addMinutes} $</td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.callRecording")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>
                  <FontAwesomeIcon
                    className={
                      plan.recordCalls ? "plan-feature-check" : "plan-feature-x"
                    }
                    icon={plan.recordCalls ? faCheck : faTimes}
                  />
                </td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.callTranscription")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>
                  <FontAwesomeIcon
                    className={
                      plan.transcribeCalls
                        ? "plan-feature-check"
                        : "plan-feature-x"
                    }
                    icon={plan.transcribeCalls ? faCheck : faTimes}
                  />
                </td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.simultaneousCalls")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>{plan.simultaneousCalls}</td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.localNumber")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>
                  {plan.localPhoneNumber ? (
                    <FontAwesomeIcon
                      className="plan-feature-check"
                      icon={faCheck}
                    />
                  ) : (
                    "US"
                  )}
                </td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.whatsappChatbot")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>
                  {plan.whatsappChatbotIncluded ? (
                    <FontAwesomeIcon
                      className="plan-feature-check"
                      icon={faCheck}
                    />
                  ) : (
                    t("plansSection.additional")
                  )}
                </td>
              ))}
            </tr>
            <tr>
              <td>{t("plansSection.webChatbot")}</td>
              {plans.map((plan) => (
                <td key={plan.id}>
                  {plan.webChatbotIncluded ? (
                    <FontAwesomeIcon
                      className="plan-feature-check"
                      icon={faCheck}
                    />
                  ) : (
                    t("plansSection.additional")
                  )}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default PlansSection;
